import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { registerProductControllerContext } from './RegisterProductController'

function RegisterProductHeader() {
  const registerProductController = useContext(registerProductControllerContext)
  const product = registerProductController.product[0]

  const headerTitle = product._id ? `Edit Product - ${product._id.toUpperCase()}` : `Register New Product`

  return ( <ContentHeader title={headerTitle} /> )
}

export default React.memo(RegisterProductHeader)